<template>
	<div>
		<BaseHeader :title="$t('overview_activities').toString()">
			<div class="flex items-center space-x-4">
				<BaseButton class="btn-default" @click="showOnlyNew = !showOnlyNew" :disabled="isLoading">
					<div v-if="showOnlyNew">Alle</div>
					<div v-else>{{ $t('only_unread') }}</div>
				</BaseButton>

				<BaseButton class="btn-default cursor-pointer" @click="readAllNotifications" :disabled="isLoading">
					{{ $t('set_to_read') }}
				</BaseButton>
			</div>
		</BaseHeader>
		<div class="main" ref="notificationTable">
			<div v-if="$store.getters.getNotifications && $store.getters.getNotifications.length && !isLoading">
				<div class="flex flex-col">
					<div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
						<div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
							<div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
								<table class="min-w-full divide-y divide-gray-200">
									<thead>
										<tr>
											<th class="px-6 py-3 bg-gray-50 text-left text-sm leading-4 font-medium text-gray-500 uppercase tracking-wider">
												{{ $t('name') }}
											</th>
											<th class="px-6 py-3 bg-gray-50 text-left text-sm leading-4 font-medium text-gray-500 uppercase tracking-wider">
												{{ $t('time_') }}
											</th>
											<th
												class="px-6 py-3 bg-gray-50 text-left text-sm leading-4 font-medium text-gray-500 uppercase tracking-wider md:hidden lg:block"
											>
												{{ $t('vehicle_owner') }}
											</th>
											<th class="px-6 py-3 bg-gray-50 text-left text-sm leading-4 font-medium text-gray-500 uppercase tracking-wider">
												{{ $t('author') }}
											</th>
											<th class="px-6 py-3 bg-gray-50"></th>
										</tr>
									</thead>
									<tbody>
										<NotificationRow :notification="notification" v-for="notification in rows" :key="notification.id" />
									</tbody>
								</table>
								<div class="mb-8" style="max-height: 40px" v-if="loadMore">
									<LoadingSpinner :height="40" />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div v-else-if="isLoading">
				<LoadingSpinner />
			</div>
			<div v-else>{{ $t('up_to_date') }}</div>
		</div>
	</div>
</template>

<script>
import BaseHeader from '@/components/navigation/BaseHeader';
import NotificationRow from '@/components/rows/NotificationRow';
import LoadingSpinner from '@/components/navigation/LoadingSpinner';
import BaseButton from '@/components/forms/buttons/BaseButton.vue';
import NotificationRepository from '@/api/repositories/NotificationRepository';

export default {
	name: 'Notifications',
	components: { BaseButton, LoadingSpinner, NotificationRow, BaseHeader },
	data() {
		return {
			showOnlyNew: false,
			isLoading: false,
			loadMore: false,
			totalNotifications: 0,
			lastPage: 1,
			currentPage: 1,
		};
	},
	mounted() {
		this.isLoading = true;
		window.addEventListener('scroll', this.onScroll);
		this.$store.dispatch('resetNotifications');
		this.$store.dispatch('updateNotifications', { page: this.currentPage }).then(response => {
			this.lastPage = response.lastPage;
			this.currentPage = response.currentPage;
			this.isLoading = false;
		});
	},
	methods: {
		onScroll() {
			const listLength = 40 * (this.currentPage * 25); // TODO: more testing necessary to see if it works on different devices

			if (listLength <= document.documentElement.scrollTop + 300 && !this.loadMore && this.lastPage > this.currentPage) {
				this.loadMore = true;
				this.$store.dispatch('updateNotifications', { page: this.currentPage + 1 }).then(response => {
					this.lastPage = response.lastPage;
					this.currentPage = response.currentPage;
					this.loadMore = false;
				});
			}
		},
		readAllNotifications() {
			NotificationRepository.setAllToRead()
				.then(response => {
					this.$store.dispatch('updateNotifications');
				})
				.catch(error => {
					this.$swal(this.$t('general.error').toString(), this.$t('entries_not_marked_as_read').toString(), 'error');
				});
		},
	},
	computed: {
		rows() {
			if (this.showOnlyNew) {
				return this.$store.getters.getUnreadNotifications;
			} else {
				return this.$store.getters.getNotifications;
			}
		},
	},
};
</script>
